module.exports = __webpack_public_path__ + "img/wechat.c559c9e0.jpeg";